import uuidv4 from "../../utils/uuidv4";

const THEME_PATH = "esir--bus-theme";
const COMPUTER_INDENTITY_PATH = "esir--bus-uid-computer";
const SESSION_ID_PATH = "esir-bus-session_id";
const TRAINING_MODE_PATH = "esir-bus-training";
const OPERATOR_PATH = "esir-bus-operator";
const USER_PATH = "esir-bus-userInfo";
const SELECTED_LOCATION_PATH = "esir-bus-selected-location";
const APP_VERSION_PATH = "esir-bus-app-version";

// ----------- LOKACIJA -------------------
export function setSessionSelectedLocation(location) {
  localStorage.setItem(SELECTED_LOCATION_PATH, JSON.stringify(location));
}

export function getSessionSelectedLocation() {
  return localStorage.getItem(SELECTED_LOCATION_PATH)
    ? JSON.parse(localStorage.getItem(SELECTED_LOCATION_PATH))
    : undefined;
}

// ----------- USER INFO -------------------

// export function setSessionUser(){
//   localStorage.setItem(USER_PATH, JSON.stringify(location));
// }

export function getSessionUser() {
  return localStorage.getItem(USER_PATH)
      ? JSON.parse(localStorage.getItem(USER_PATH))
      : undefined;
}

// ----------- OPERATER -------------------

export function setSessionOperator(operator) {
  localStorage.setItem(OPERATOR_PATH, JSON.stringify(operator));
}

export function removeSessionOperator() {
  localStorage.removeItem(OPERATOR_PATH);
}

export function getSessionOperator() {
  return localStorage.getItem(OPERATOR_PATH)
    ? JSON.parse(localStorage.getItem(OPERATOR_PATH))
    : undefined;
}

// ----------- VERZIJA -------------------
export function getSessionAppVersion() {
  return localStorage.getItem(APP_VERSION_PATH)
    ? parseFloat(localStorage.getItem(APP_VERSION_PATH))
    : null;
}

export function setSessionAppVersion(version) {
  localStorage.setItem(APP_VERSION_PATH, version.toString());
}

// ----------- SESIJA -------------------
export function getAndCreateUniqueComputerUid() {
  let id = uuidv4();
  let storedSession = localStorage.getItem(COMPUTER_INDENTITY_PATH);
  if (!storedSession) {
    localStorage.setItem(COMPUTER_INDENTITY_PATH, id);
    return id;
  }
  return storedSession;
}

export function setSessionId(sessionId) {
  localStorage.setItem(SESSION_ID_PATH, sessionId);
}

export function getSessionId() {
  return localStorage.getItem(SESSION_ID_PATH);
}

export function deleteLocalSessionId() {
  localStorage.removeItem(SESSION_ID_PATH);
}

// ----------- OBUKA MOD -------------------
export function setSessionTrainingMode(active) {
  localStorage.setItem(TRAINING_MODE_PATH, active);
}

export function getSessionTrainingMode() {
  return localStorage.getItem(TRAINING_MODE_PATH) ? (localStorage.getItem(TRAINING_MODE_PATH) === "true") : false;
}

// ----------- TEMA -------------------
export function setSessionTheme(theme) {
  localStorage.setItem(THEME_PATH, theme);
}

export function getSessionTheme() {
  let theme = localStorage.getItem(THEME_PATH);
  return theme ? theme : "light";
}

// ----------- OSTALO -------------------
export function clearSession(isLogout = false) {
  let itemsToRemove;
  if (isLogout) {
    itemsToRemove = [SELECTED_LOCATION_PATH, TRAINING_MODE_PATH, OPERATOR_PATH];
  } else {
    itemsToRemove = [TRAINING_MODE_PATH, OPERATOR_PATH];
  }
  itemsToRemove.forEach(item => localStorage.removeItem(item));
}

export function isTest() {
  if(getSessionSelectedLocation() === null){
    return false
  }
  return getSessionSelectedLocation().vsdcURL.includes("sandbox")
}